// @flow

import { List, Map, fromJS } from 'immutable';

export const GET_ITEMS = 'App/Grid/GET_ITEMS';
export const GET_ITEMS_SUCCESS = 'App/Grid/GET_ITEMS_SUCCESS';
export const GET_ITEMS_FAIL = 'App/Grid/GET_ITEMS_FAIL';
export const CLEAR_ITEMS = 'App/Grid/CLEAR_ITEMS';

const initialState = Map({
  getItemsLoading: false,
  itemsData: null,
  getItemsFail: null,
});

export default (state : any = initialState, action : any = {}) => {
  switch (action.type) {
    case GET_ITEMS:
      return state.merge({
        getItemsLoading: true,
        getListsFail: null,
      });
    case GET_ITEMS_SUCCESS:
      return state.merge({
        getItemsLoading: false,
        itemsData: fromJS(action.data),
      });
    case GET_ITEMS_FAIL:
      return state.merge({
        getItemsLoading: false,
        getItemsFail: fromJS(action.data),
      });
    case CLEAR_ITEMS:
      return state.set('itemsData', List([]));
    default:
      return state;
  }
};

export const getItems = (data : any) => (dispatch : any) => dispatch({ type: GET_ITEMS, data });

export const clearItems : any = () => ({ type: CLEAR_ITEMS });
